import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { useSearch } from '../../services/search/useSearch.js';
import { zip } from '../../utils/fp/zip.js';
import { joinPath } from '../../utils/url.js';
import { Dialog } from '../DialogManager/Dialog.js';
import { Sitemap } from '../Sitemap/Sitemap.js';
import { SearchInput } from './SearchInput.js';
export const SearchDialog = JSX(({ initialQuery, navigationItems }) => {
    const basePathList = useMemo(() => navigationItems?.map((_) => _.href || '/'), [navigationItems]);
    const [searchResult, searchInputProps] = useSearch({
        basePathList,
        initialQuery,
    });
    const searchItems = useMemo(() => combineTopItemsAndSearchResult(navigationItems)(searchResult), [navigationItems, searchResult]);
    return (_jsx(Dialog, { head: _jsx(SearchInput, { autoFocus: true, ...searchInputProps }), children: _jsx(Sitemap, { navigationItems: searchItems }) }));
});
const combineTopItemsAndSearchResult = (topItems) => (searchResult) => topItems?.length && searchResult?.length
    ? zip(topItems, searchResult).map(([_, portalSearchResult]) => ({
        ..._,
        items: portalSearchResult?.map(({ title, uri }) => ({ text: title, href: joinPath('/', uri) })),
    }))
    : [];
//# sourceMappingURL=SearchDialog.js.map